import React, { Component } from 'react';
import logo from '../assets/images/littlescribe-logo-dark-bg.png';
import './landing.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import DatePicker from 'react-date-picker';
import ReactPlayer from 'react-player/lazy';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, PinterestShareButton, TwitterShareButton } from 'react-share';
import { EmailIcon, FacebookIcon, LinkedinIcon, PinterestIcon, TwitterIcon } from 'react-share';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

var minBase = 0;
const aspectRatio = 297 / 210;
var adjBaseUnits = 0;
var adjBaseWidth = 0;
var adjBaseHeight = 0;
const defaultStateText = 'Select State';
const defaultCountryText = 'Select Country';
const defaultFavAuthorText = 'Select Favourite Author';
const defaultDateFilterText = 'Select Default Filter';
const placeholderArr = [
	{
		front_cover: '/placeholders/1.jpg',
		back_cover: '/placeholders/2.jpg',
	},
	{
		front_cover: '/placeholders/3.jpg',
		back_cover: '/placeholders/4.jpg',
	},
	{
		front_cover: '/placeholders/5.jpg',
		back_cover: '/placeholders/6.jpg',
	},
	{
		front_cover: '/placeholders/7.jpg',
		back_cover: '/placeholders/8.jpg',
	},
	{
		front_cover: '/placeholders/9.jpg',
		back_cover: '/placeholders/10.jpg',
	},
	{
		front_cover: '/placeholders/11.jpg',
		back_cover: '/placeholders/12.jpg',
	},
	{
		front_cover: '/placeholders/13.jpg',
		back_cover: '/placeholders/14.jpg',
	},
	{
		front_cover: '/placeholders/15.jpg',
		back_cover: '/placeholders/16.jpg',
	},
	{
		front_cover: '/placeholders/17.jpg',
		back_cover: '/placeholders/18.jpg',
	},
	{
		front_cover: '/placeholders/19.jpg',
		back_cover: '/placeholders/20.jpg',
	},
	{
		front_cover: '/placeholders/21.jpg',
		back_cover: '/placeholders/22.jpg',
	},
	{
		front_cover: '/placeholders/23.jpg',
		back_cover: '/placeholders/24.jpg',
	},
	{
		front_cover: '/placeholders/25.jpg',
		back_cover: '/placeholders/26.jpg',
	},
	{
		front_cover: '/placeholders/27.jpg',
		back_cover: '/placeholders/28.jpg',
	},
	{
		front_cover: '/placeholders/29.jpg',
		back_cover: '/placeholders/30.jpg',
	},
	{
		front_cover: '/placeholders/31.jpg',
		back_cover: '/placeholders/32.jpg',
	},
	{
		front_cover: '/placeholders/33.jpg',
		back_cover: '/placeholders/34.jpg',
	},
];
const styles = {
    textAlign: 'center',
};
class Landing extends Component {
	constructor(props) {
		if (document.body.clientWidth < 760) {
			minBase = 100;
		} else {
			minBase = 120;
		}

		adjBaseUnits = Math.floor(document.body.clientWidth / minBase);
		adjBaseWidth = document.body.clientWidth / adjBaseUnits;
		adjBaseHeight = adjBaseWidth * aspectRatio;
		super(props);
		this.state = {
			width: 0,
			height: 0,
			minBase: minBase,
			aspectRatio: 297 / 210,
			adjBaseUnits: adjBaseUnits,
			adjBaseWidth: adjBaseWidth,
			adjBaseHeight: adjBaseHeight,
			open: false,
			selectedPost: null,
			firstName: '',
			authorName: '',
			readerName: '',
			date_filter: '',
			link: '',
			tilesArray: [],
			skip: 0,
			limit: 100,
			hasMore: true,
			countries: [],
			countryStates: ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'NT', 'TAS', 'ACT'],
			beforeAfter: ['before', 'after'],
			favouriteAuthors: [],
			selectedCountry: defaultCountryText,
			selectedFavAuthor: defaultFavAuthorText,
			selectedCountryState: defaultStateText,
			selectedBAValue: defaultDateFilterText,
			searchText: '',
			selectedDate: '',
			defaultState: defaultStateText,
			defaultCountry: defaultCountryText,
			defaultFavAuthor: defaultFavAuthorText,
			defaultDateFilter: defaultDateFilterText,
		};

		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
		this.handleCountryChange = this.handleCountryChange.bind(this);
		this.handleAuthorChange = this.handleAuthorChange.bind(this);
		this.handleCountryStateChange = this.handleCountryStateChange.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleBeforeAfterChange = this.handleBeforeAfterChange.bind(this);
		this.handleApplyFilterChange = this.handleApplyFilterChange.bind(this);
		this.handleResetClick = this.handleResetClick.bind(this);
	}
	searchStory = async (event) => {
		let keyword = event.target.value;
		this.setState({
			searchText: keyword,
		});
		if (keyword.length >= 3) {
			this.setState({
				tilesArray: [],
			});
			try {
				setTimeout(() => {
					this.fetchTiles();
				}, 1000);
			} catch (err) {
				console.log('😱 request failed');
			}
		} else {
			// do nothing until more characters entered
		}
		if (keyword.length === 0) {
			this.setState({
				tilesArray: [],
			});
			this.fetchTiles();
		}
	};
	processTiles(data) {
		var startTile = 0;
		var lastPlaceHolder = 0;
		var rowLength = 0;
		var insertPosition;
		for (var i = 0; i < data.length; i++) {
			rowLength += data[i].orientation;
			if (rowLength === adjBaseUnits) {
				startTile = i + 1;
				rowLength = 0;
			} else if (rowLength > adjBaseUnits) {
				insertPosition = Math.floor(Math.random() * (i - startTile)) + startTile;
				data.splice(insertPosition, 0, {
					tile_type: 'placeholder',
					orientation: 1,
					front_cover: placeholderArr[lastPlaceHolder].front_cover,
					back_cover: placeholderArr[lastPlaceHolder].back_cover,
				});
				if (lastPlaceHolder === placeholderArr.length - 1) {
					lastPlaceHolder = 0;
				} else {
					lastPlaceHolder = lastPlaceHolder + 1;
				}
				startTile = i + 1;
				rowLength = 0;
			} else {
				// do nothing
			}
		}
		return data;
	}

	fetchTiles = async () => {
		const { skip, limit, tilesArray, selectedDate, searchText, selectedCountry, selectedFavAuthor, selectedCountryState, selectedBAValue } = this.state;
		// console.log('fetch tiles >>', selectedDate, searchText, selectedCountry, selectedFavAuthor, selectedCountryState, selectedBAValue);
		var searchApiUrl = '';
		var date = ';';
		if (searchText !== '') {
			searchApiUrl += `&q=${searchText}`;
		}
		if (selectedCountry !== defaultCountryText && selectedCountry !== '') {
			searchApiUrl += `&country=${selectedCountry}`;
		}
		if (selectedFavAuthor !== defaultFavAuthorText && selectedFavAuthor !== '') {
			searchApiUrl += `&fav_author=${selectedFavAuthor}`;
		}
		if (selectedCountryState !== defaultStateText) {
			searchApiUrl += `&state=${selectedCountryState}`;
		}
		if (selectedDate !== '') {
			var YYYY = selectedDate.getFullYear();
			var DD = selectedDate.getMonth() + 1;
			var MM = selectedDate.getDate();
			date = YYYY + '-' + DD + '-' + MM;
			searchApiUrl += `&date=${date}`;
		}
		if (selectedBAValue !== '' && selectedBAValue !== defaultDateFilterText) {
			searchApiUrl += `&date_filter=${selectedBAValue}`;
		}
		console.log('searchApiUrl:', searchApiUrl);
		var url = `${process.env.REACT_APP_BASE_URL}/v1/story-wall?skip=${skip}&limit=${limit}${searchApiUrl}`;
		try {
			const result = await fetch(url);
			var allData = await result.json();
			var data = allData.tile_data;
			var adjustedData = await this.processTiles(data);
			if (data.length < this.state.limit) {
				this.setState({ hasMore: false, skip: 0 });
			}
			if (adjustedData.length > 0) {
				this.setState({
					tilesArray: tilesArray.concat(adjustedData),
					skip: skip + this.state.limit,
				});
				console.log('tiles array', tilesArray.concat(adjustedData));
			} else {
				this.setState({
					tilesArray: tilesArray,
				});
			}
		} catch (err) {
			console.log('😱 request failed');
		}
	};
	fetchFilterDropdownLists = async () => {
		try {
			var url = `${process.env.REACT_APP_BASE_URL}/v1/story-wall/filters`;
			const result = await fetch(url);
			const data = await result.json();
			this.setState({
				countries: data.filters.country,
				favouriteAuthors: data.filters.fav_author,
			});
		} catch (err) {
			console.log('😱 request failed');
		}
	};
	componentDidMount() {
		this.fetchFilterDropdownLists();
		setTimeout(() => {
			this.fetchTiles();
		}, 1000);
		window.addEventListener('resize', this.updateWindowDimensions);
		this.updateWindowDimensions();
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}
	handleResetClick() {
		this.setState({
			tilesArray: [],
			skip: 0,
			hasMore: true,
			searchText: '',
		});
		this.setState({
			selectedCountry: defaultCountryText,
			selectedCountryState: defaultStateText,
			selectedFavAuthor: defaultFavAuthorText,
			selectedBAValue: defaultDateFilterText,
			selectedDate: '',
			defaultState: defaultStateText,
			defaultCountry: defaultCountryText,
			defaultFavAuthor: defaultFavAuthorText,
			defaultDateFilter: defaultDateFilterText,
		});
		setTimeout(() => {
			this.fetchTiles();
		}, 1000);
	}
	handleCountryChange(e) {
		this.setState({
			selectedCountry: e.target.value,
		});
	}
	handleCountryStateChange(e) {
		this.setState({
			selectedCountryState: e.target.value,
		});
	}
	handleAuthorChange(e) {
		this.setState({
			selectedFavAuthor: e.target.value,
		});
	}
	handleDateChange = (date) => {
		this.setState({ selectedDate: date });
	};

	handleBeforeAfterChange(e) {
		this.setState({
			selectedBAValue: e.target.value,
		});
	}
	handleApplyFilterChange() {
		this.setState({ selectedCountry: this.state.selectedCountry });
		this.setState({ selectedCountryState: this.state.selectedCountryState });
		this.setState({ selectedFavAuthor: this.state.selectedFavAuthor });
		this.setState({ selectedDate: this.state.selectedDate });
		this.setState({ selectedBAValue: this.state.selectedBAValue });
		this.setState({
			tilesArray: [],
			skip: 0,
		});
		setTimeout(() => {
			this.fetchTiles();
		}, 1000);
	}
	fetchMoreListItems = () => {
		this.fetchTiles();
	};
	updateWindowDimensions() {
		this.setState({ adjBaseUnits: Math.floor(document.body.clientWidth / this.state.minBase) });
		this.setState({ adjBaseWidth: document.body.clientWidth / this.state.adjBaseUnits });
		this.setState({ adjBaseHeight: this.state.adjBaseWidth * this.state.aspectRatio });
	}
	onOpenModal = (i) => {
		this.setState({
			open: true,
			selectedPost: i, // When a post is clicked, mark it as selected
		});
	};

	onCloseModal = () => {
		this.setState({ open: false });
	};

	renderModal = () => {
		if (this.state.selectedPost !== null) {
			const tile = this.state.tilesArray[this.state.selectedPost];
            return (
				<Modal
					center
					classNames={{
						overlay: 'customOverlay',
						modal: 'customModal',
					}}
					open={this.state.open}
					onClose={this.onCloseModal}
				>
					<div className="bg-theme1 text-center py-3">
						<span className="">Welcome to the library of stories by kids!</span>
					</div>
					<div className="text-center m-0 p-0">
						<div className="p-2 mt-3">
							<p className="m-0">
								Hi, I'm {tile.author} from {tile.state}, {tile.country}.
								<br />
								<br />I would love
								<br />
								<span className="txt-theme2 text-uppercase font-weight-bold">{tile.reader_name ? tile.reader_name : 'you'}</span>
								<br />
								to read my story.
								<br />
								<br />
								My <span className="pizza">favourite</span> author is {tile.favourite_author ? tile.favourite_author + '.' : 'me!'}
							</p>
						</div>
						<div className="my-3 align-left pt-4 pb-2" style={{ background: 'url(./images/mini-writing-festival-arrow.png) no-repeat left/contain' }}>
							{/* <img src="./images/mini-writing-festival-arrow.png" alt="" /> */}
							<a type="button" className="btn bg-theme1" href={tile.link} target="_blank" rel="noopener noreferrer">
								<p className="m-0">Read my story</p>
							</a>
						</div>
					</div>
				</Modal>
			);
		} else {
			return (
				<div className="modal fade" id="additionalContent" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
					<div className="modal-dialog" role="document">
						<div className="modal-content text-center">
							<div>
								<div className="modal-header">
									<button type="button" className="close" data-dismiss="modal" aria-label="Close">
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div className="modal-body d-flex flex-column"></div>
							</div>
						</div>
					</div>
				</div>
			);
		}
	};

	render() {
		return (
			<div className="container-fluid bg-black">
				<div className="row">
					<div className="col-sm-6 p-2">
						<TwitterShareButton url={window.location.href} hashtags={['storystarterwall']} via="littlescribe">
							<TwitterIcon size={32} round={true} />
						</TwitterShareButton>
						<FacebookShareButton url={window.location.href} quote="You're going to love the Littlescribe Story Starter Wall" hashtag="storystarterwall">
							<FacebookIcon size={32} round={true} />
						</FacebookShareButton>
						<PinterestShareButton url={window.location.href} media="https://storystarterwall.littlescribe.com/images/littlescribe-logo-dark-bg.png">
							<PinterestIcon size={32} round={true}></PinterestIcon>
						</PinterestShareButton>
						<LinkedinShareButton url={window.location.href}>
							<LinkedinIcon size={32} round={true}></LinkedinIcon>
						</LinkedinShareButton>
						<EmailShareButton url={window.location.href} subject="You're going to love the Littlescribe Story Starter Wall">
							<EmailIcon size={32} round={true}></EmailIcon>
						</EmailShareButton>
					</div>
					<div className="col-sm-6 p-2 text-right">
						<h3 className="txt-theme2">
							<a className="txt-white" href="https://www.littlescribe.com/contact-us/" target="_blank" rel="noopener noreferrer">
								CONTACT US
							</a>{' '}
							|{' '}
							<span>
								<a className="txt-theme1" href="https://app.littlescribe.com/#/login" target="_blank" rel="noopener noreferrer">
									LOGIN
								</a>
							</span>{' '}
							|{' '}
							<a className="txt-white" href="https://app.littlescribe.com/#/register" target="_blank" rel="noopener noreferrer">
								SIGN UP
							</a>
						</h3>
					</div>
				</div>
				<header className="app-header row">
					{/* <div className="col-12"> */}
					<img src={logo} className="app-logo" alt="logo" />
					<h1 className="txt-theme2">Welcome to the Story Starter Wall</h1>
					<h2>Stories by kids ready for the world to read!</h2>
					{/* </div> */}
				</header>
				<div className="row">
					<div className="col-12">
						<div className="row py-2 px-0">
							<div className="col-sm-4 pr-3">
								<input className="form-control mt-2" type="text" placeholder="Search" aria-label="Search" onChange={(e) => this.searchStory(e)} value={this.state.searchText} />
							</div>
							<div className="col-sm-8">
								<button className="btn bg-theme1 mt-2 float-right" onClick={this.handleResetClick}>
									Reset
								</button>
								<button className="btn bg-theme1 mt-2 mr-2 float-right" data-toggle="collapse" data-target="#filterPopup" aria-expanded="false" aria-controls="filterPopup">
									Filter
								</button>
								<a className="btn bg-theme1 mt-2 mr-2 float-right" href="https://app.littlescribe.com/#/create" target="_blank" rel="noopener noreferrer">
									Add to the Story Starter Wall
								</a>
								<div className="col column-position">
									<div className="collapse multi-collapse" id="filterPopup">
										{/* <form> */}
										<div className="card card-body">
											Select State (AU only)
											<select disabled={this.state.selectedCountry !== 'Australia' && this.state.selectedCountry !== 'Select Country'} onChange={this.handleCountryStateChange} value={this.state.selectedCountryState}>
												<option value={defaultStateText}>{defaultStateText}</option>
												{this.state.countryStates.map((state) => (
													<option key={state} value={state}>
														{state}
													</option>
												))}
											</select>
											<br />
											Select Favourite Author
											<select onChange={this.handleAuthorChange} value={this.state.selectedFavAuthor}>
												<option value={defaultFavAuthorText}>{defaultFavAuthorText}</option>
												{this.state.favouriteAuthors.map((author) => (
													<option key={author} value={author}>
														{author}
													</option>
												))}
											</select>
											<br />
											Select Country
											<select disabled={this.state.selectedCountry !== 'Australia' && this.state.selectedCountryState !== defaultStateText} onChange={this.handleCountryChange} value={this.state.selectedCountry}>
												<option value={defaultCountryText}>{defaultCountryText}</option>
												{this.state.countries.map((country) => (
													<option key={country} value={country}>
														{country}
													</option>
												))}
											</select>
											<br />
											<DatePicker onChange={this.handleDateChange} value={this.state.selectedDate} />
											<br />
											Select Before/After
											<select onChange={this.handleBeforeAfterChange} value={this.state.selectedBAValue}>
												<option value={defaultDateFilterText}>{defaultDateFilterText}</option>
												{this.state.beforeAfter.map((val) => (
													<option key={val} value={val}>
														{val}
													</option>
												))}
											</select>
											<br />
											<button className="btn btn-primary" data-toggle="collapse" data-target="#filterPopup" aria-expanded="false" aria-controls="filterPopup" onClick={this.handleApplyFilterChange}>
												Apply
											</button>
										</div>
										{/* </form> */}
									</div>
								</div>
							</div>
						</div>
						<div className="row mt-2">
							<div className="col-12 text-right">
								<h4 className="txt-theme2 d-inline-block">
									<a className="txt-white" href="https://www.youtube.com/watch?v=bp2C_9Qf2RU" target="_blank" rel="noopener noreferrer">
										Instructions for Parents
									</a>
								</h4>{' '}
								|{' '}
								<h4 className="txt-theme2 d-inline-block">
									<a className="txt-white" href="https://www.youtube.com/watch?v=bdfb55Snlfc" target="_blank" rel="noopener noreferrer">
										An overview of the Story Starter Wall
									</a>
								</h4>{' '}
								|{' '}
								<h4 className="txt-theme2 d-inline-block">
									<a className="txt-white" href="https://www.youtube.com/watch?v=Xwiex_niAjQ" target="_blank" rel="noopener noreferrer">
										How to use the Story Starter Wall
									</a>
								</h4>
							</div>
						</div>
						<div className="row tile-area tiles pt-2 h-auto">
							<InfiniteScroll dataLength={this.state.tilesArray.length} next={this.fetchMoreListItems} hasMore={this.state.hasMore} loader={this.state.hasMore ? <p className="App-intro text-white">loading ...</p> : ''}>
								{this.state.tilesArray.map((item, i) => {
									return (
										<div className="column" key={i}>
											<div style={{ width: this.state.adjBaseWidth * item.orientation, height: this.state.adjBaseHeight }}>
												<div className="flip-box">
													<div className="flip-box-inner text-center">
														{item.tile_type === 'project' && <div className="flip-box-front" style={{ width: this.state.adjBaseWidth * item.orientation, height: this.state.adjBaseHeight, background: 'url(' + item.front_cover + ') no-repeat center/cover' }}></div>}
														{item.tile_type === 'placeholder' && (
															<div className="flip-box-front" style={{ width: this.state.adjBaseWidth * item.orientation, height: this.state.adjBaseHeight, background: 'url(' + process.env.PUBLIC_URL + item.front_cover + ') no-repeat center/cover' }}></div>
														)}
														{item.tile_type === 'project' && (
															<div className="flip-box-back d-table" style={{ width: this.state.adjBaseWidth * item.orientation, height: this.state.adjBaseHeight }}>
																<div className="p-1 d-table-cell align-middle">
																	<h3 className="m-0">
																		Hi, I'm {item.author} and I would love <span className="txt-theme2 text-uppercase">{item.reader_name ? item.reader_name : 'you'}</span> to read my story.
																	</h3>
																	<button className="btn p-1 mt-2" data-target="#additionalContent" onClick={() => this.onOpenModal(i)}>
																		<h3 className="m-0">Next</h3>
																	</button>
																</div>
															</div>
														)}
														{item.tile_type === 'placeholder' && (
															<div className="flip-box-back" style={{ width: this.state.adjBaseWidth * item.orientation, height: this.state.adjBaseHeight, background: 'url(' + process.env.PUBLIC_URL + item.back_cover + ') no-repeat center/cover' }}>
																<a className="btn p-1 position-relative va-bottom" href="https://www.littlescribe.com/authors/" target="_blank" rel="noopener noreferrer">
																	<p className="m-0 small">Let's write together</p>
																</a>
															</div>
														)}
													</div>
												</div>
												{item.tile_type === 'video' && (
													<div className="d-flex flex-column" style={{ width: this.state.adjBaseWidth * item.orientation, height: this.state.adjBaseHeight }}>
														<ReactPlayer controls url={item.link} width="100%" height="100%" />
													</div>
												)}
												{item.tile_type === 'image' && <div className="d-flex flex-column" style={{ width: this.state.adjBaseWidth * item.orientation, height: this.state.adjBaseHeight, background: 'url(' + item.front_cover + ') no-repeat center/cover' }}></div>}
											</div>
										</div>
									);
								})}
								{this.renderModal()}
							</InfiniteScroll>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default Landing;
